@if (loading()) {
  <fa-icon [icon]="spinnerIcon" animation="spin" />
  @if (displayText && text()) {
    <div>{{ text() }}</div>
  }
}
